import styled from 'styled-components'

import { FaPlusCircle, FaCalendarDay } from "react-icons/fa"

export const Container = styled.div`
width: 100%;
height: 100vh;
background-color: ${({ theme }) => theme.colors.background};
padding: 0;
margin: 0;
`;

export const ContentContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.background};
  padding-top: 16px;
`

// `isFallback` = negocio sem imagem (url nula ou quebrada). Nesse caso
// mostra a logo do app sobre fundo bege, com `contain` + padding para a
// logo (1.51:1) caber inteira no container quase quadrado, sem cortar.
export const Logo = styled.div`
  width: 50vw;
  height: 45vw; 
  background-color: ${({ theme }) => theme.colors.background};
  background-image: url(${({ url }) => url});
  background-size: ${({ isFallback }) => isFallback ? 'contain' : 'cover'};
  background-position: center center;
  background-repeat: no-repeat;
  background-origin: content-box;  
  padding: ${({ isFallback }) => isFallback ? '16px' : '0'};
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: 14px;
  margin-bottom: 32px;  
  
  @media (min-width: 768px) {
    width: 15vw;
    height: 15vw;
  }

  /* @media (min-width: 1024px) {
    width: 30vw;
    height: 25vw;
  } */
  
  
`

export const ActionsContainer = styled.div`
  width: 100%; 
  height: 70%;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  padding-top: 32px;

   @media (min-width: 768px) {
    width: 40vw;
    height: 28vw;
    justify-content: space-between
  }
`

export const ActionButton = styled.button`
  width: 40%;
  height: 130px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: 14px; 
  transition: border-color 0.2s, background-color 0.2s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.accentOnSurface};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.surfaceAlt};
    border-color: ${({ theme }) => theme.colors.accentOnSurface};
  }
`

export const ActionButtonTitle = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.surfaceText};
`

export const SchedulingIcon = styled(FaPlusCircle).attrs(({ theme }) => ({
  color: theme.colors.accentOnSurface,
  size: 28,
}))``;


export const SchedulingsIcon = styled(FaCalendarDay).attrs(({ theme }) => ({
  color: theme.colors.accentOnSurface,
  size: 28,
}))``;
